import axiosInstance from '../../axiosInstance';

const logoutFromAllDevices = async ({ userId }) => {
  await axiosInstance.patch(
    `/api/admin-actions/v2/refresh-token/${userId}/invalidate-all`,
  );
};

export default logoutFromAllDevices;
